import { render, staticRenderFns } from "./DynamicDialogInformation.vue?vue&type=template&id=60838034&"
import script from "./DynamicDialogInformation.vue?vue&type=script&lang=js&"
export * from "./DynamicDialogInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports